<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="450px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="small" label-width="120px">
      <el-form-item label="产品类型:" prop="productType">
        <el-input v-model="addForm.productType" :disabled="title == '编辑'"></el-input>
      </el-form-item>
      <el-form-item label="主导拍摄提成:" prop="incomeMain">
        <el-input v-model="addForm.incomeMain" @input="addForm.incomeMain=addForm.incomeMain.replace(/^0+(\d)|[^\d]+/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="辅助拍摄提成:" prop="incomeDeputy">
        <el-input v-model="addForm.incomeDeputy" @input="addForm.incomeDeputy=addForm.incomeDeputy.replace(/^0+(\d)|[^\d]+/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="核算时间:" prop="accountingDate">
        <el-date-picker v-model="addForm.accountingDate" type="date" placeholder="选择日期" value-format="yyyyMMdd"> </el-date-picker>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    authOptions: {
      type: Array,
      default: [],
    },
    rowData: Object,
  },
  data() {
    return {
      addForm: {
        storeCodeList: [],
      },
      userId: "",
      userList: [],
      all: false,
      rules: {
        productType: [{ required: true, message: "不能为空", trigger: "blur" }],
        incomeMain: [{ required: true, message: "不能为空", trigger: "blur" }],
        incomeDeputy: [{ required: true, message: "不能为空", trigger: "blur" }],
        accountingDate: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      loading: false,
      loadingButtom: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  watch: {
    storeCodeList(val, old) {
      if (!val || !val.length) return;
      this.all = val.length != this.authOptions.length ? false : true;
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return this.rowData ? "编辑" : "新增";
    },
    storeCodeList() {
      return this.addForm.storeCodeList ? JSON.parse(JSON.stringify(this.addForm.storeCodeList)) : [];
    },
  },
  mounted() {
    if (this.rowData) {
      let addForm = JSON.parse(JSON.stringify(this.rowData));
      this.addForm = addForm;
      this.$set(this.addForm,'accountingDate',addForm.accountingDate + '')
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = {
          ...this.addForm,
        };
        this.$q.newProduct
          .shootingAccountingConfigSave({ data: data })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    remoteMethod(query) {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "searchUserInfoByName";
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.userList = res.data.list;
          this.loading = false;
        }
      });
    },
    handleUserInfoChange(data) {
      const activeObj = this.userList.find((v) => v.userId === this.userId);
      this.$set(this.addForm, "userId", activeObj.userId);
      this.$set(this.addForm, "workNo", activeObj.workNo);
      this.$set(this.addForm, "userName", activeObj.userName);
      this.$set(this.addForm, "workJobs", activeObj.workJobs);
    },
    storeCodeChange(val) {
      if (val.includes("")) {
        this.addForm.storeCodeList = this.authOptions.map((v) => v.storeCode);
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.addForm.storeCodeList = [];
        this.all = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 220px !important
>>> .el-input
  width 220px !important

>>> .el-select__tags-text {
display: inline-block;
max-width: 60px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
